<template>
  <el-drawer :visible.sync="show" append-to-body :modal="false" direction="ltr" title="追加文书" :show-close="false" :size="350">
    <el-tree :data="tmplsTree" default-expand-all @node-click="select">
      <span slot-scope="{ node, data }">
        <span v-if="!data.isType">
          <i class="el-icon-document-copy success" v-if="data.ifRepeatable" title="允许重复！" />
          <i class="el-icon-document warning" v-else title="禁止重复！" />
          <el-link type="primary" class="sub-title left-pad">{{ node.label }}</el-link>
        </span>
        <span v-else class="left-pad">{{ node.label }}</span>
        <span v-if="data.gender && data.gender != '不限'"> （{{ data.gender }}） </span>
      </span>
    </el-tree>
  </el-drawer>
</template>
<script>
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      record: Object, // 病历
      mrs: Array, // 文书列表
    },
    data() {
      return {
        show: false,
      };
    },
    computed: {
      ...mapGetters(["Enum", "dict", "user", "permission", "token", "setting"]),
      isIp() {
        return !!this.record?.ipNo;
      },
      deptCodes() {
        // 获取当前科室及上级科室的编码数组
        let deptCodes = [this.user.deptCode];
        let dept = this.dict.Dept.find((d) => d.code == this.user.deptCode);
        if (dept) {
          dept.codeChain.split("@").forEach((d) => {
            if (d && deptCodes.findIndex((c) => c == d) == -1) {
              deptCodes.push(d);
            }
          });
        }
        return deptCodes;
      },
      validtmpls() {
        let items = this.$utils.Obj.clone((this.dict.MrTemplate || []).filter((t) => !t.disabled && t.scope == (this.isIp ? "住院" : "门诊") && (!t.deptCode || this.deptCodes.findIndex((d) => t.deptCode == d) != -1)));

        if (!this.record?.patientGender) {
          return items;
        } else {
          let gender = this.$utils.Dict.text(this.record.patientGender, "Gender");
          if (gender.indexOf("男") >= 0) {
            return items.filter((t) => t.gender == this.Enum.MrGender.男 || t.gender == this.Enum.MrGender.不限);
          }
          if (gender.indexOf("女") >= 0) {
            return items.filter((t) => t.gender == this.Enum.MrGender.女 || t.gender == this.Enum.MrGender.不限);
          }
          return items;
        }
      },
      tmplsTree() {
        let tmplsTree = [];
        let typs = (this.dict.MrType || []).map((d) => ({
          label: d.text,
          value: d.code,
          isType: true,
        }));
        for (let t of typs) {
          let items = this.validtmpls.filter((tm) => tm.type == t.value && (tm.ifRepeatable || this.mrs.findIndex((m) => m.tmplCode == tm.code) == -1));
          if (items && items.length) {
            this.$set(t, "children", items);
            t.children.forEach((c) => {
              c.label = c.name;
            });
            tmplsTree.push(t);
          }
        }

        return tmplsTree;
      },
    },
    watch: {
      visible(val) {
        this.show = val;
      },
      show(val) {
        this.$emit("update:visible", val);
      },
    },
    methods: {
      select(tmpl) {
        if (tmpl.isType) {
          return;
        }
        this.$emit("ok", tmpl);
        this.$emit("update:visible", false);
      },
    },
  };
</script>
